import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import 'bootstrap-select';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import config from '../config';

function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    age: '',
    dob: '',
    phone1: '',
    phone2: '',
    address: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [timeoutId, setTimeoutId] = useState(null);

  useEffect(() => {
    // Initialize datepicker
    $('#datepicker').datepicker({
      dateFormat: 'mm/dd/yy',
      showAnim: 'fadeIn',
      onSelect: function(dateText) {
        setFormData(prev => ({ ...prev, dob: dateText }));
      }
    });

    // Initialize select pickers
    $('.selectpicker').selectpicker();

    // Cleanup function
    return () => {
      $('#datepicker').datepicker('destroy');
      // Clear any existing timeout when component unmounts
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  // Effect to handle auto-dismissal of success messages
  useEffect(() => {
    // If there's a success status, set a timer to clear it
    if (submitStatus && submitStatus.type === 'success') {
      // Clear any existing timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      
      // Set new timeout to clear the status after 10 seconds
      const id = setTimeout(() => {
        setSubmitStatus(null);
      }, 10000); // 10 seconds
      
      setTimeoutId(id);
    }
    
    // Cleanup function to clear timeout when component unmounts or status changes
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [submitStatus, timeoutId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);
    
    // Clear any existing timeout
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }

    try {
      const response = await fetch(`${config.apiBaseUrl}/contacts/api`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitStatus({ type: 'success', message: 'Thank you for your enquiry. Our team will get back to you shortly!' });
        // Reset form
        setFormData({
          name: '',
          age: '',
          dob: '',
          phone1: '',
          phone2: '',
          address: ''
        });
        $('#datepicker').datepicker('setDate', null);
      } else {
        setSubmitStatus({ type: 'error', message: data.message || 'Error submitting form' });
      }
    } catch (error) {
      setSubmitStatus({ type: 'error', message: 'Network error. Please try again.' });
    } finally {
      setIsSubmitting(false);
    }
  };

  // Function to manually dismiss the status message
  const dismissMessage = () => {
    setSubmitStatus(null);
    if (timeoutId) {
      clearTimeout(timeoutId);
      setTimeoutId(null);
    }
  };

  return (
    <div>
      <section className="page-header">
        <div className="page-header-bg" style={{
          backgroundImage: `url('${config.baseUrl}/assets/images/backgrounds/Contact-PAGE-HEADER-(1894-434).jpg')`,
        }}>
        </div>
        <div className="container">
          <div className="page-header__inner">
            <h2>Contact</h2>
            <ul className="thm-breadcrumb list-unstyled">
              <li><a href="/">Home</a></li>
              <li><span>/</span></li>
              <li>Contact</li>
            </ul>
          </div>
        </div>
      </section>
   
      <section className="contact-page">
        <div className="container">
          <div className="section-title text-center">
            <span className="section-title__tagline">Contact with us</span>
            <h2 className="section-title__title">Feel Free to Get <span>in</span> <br/> Touch with us</h2>
          </div>
          <div className="contact-page__form-box">
            {submitStatus && (
              <div className={`alert alert-${submitStatus.type === 'success' ? 'success' : 'danger'} alert-dismissible fade show mb-4`} role="alert">
                {submitStatus.message}
                <button 
                  type="button" 
                  className="btn-close" 
                  onClick={dismissMessage}
                  aria-label="Close"
                ></button>
              </div>
            )}
            
            {/* Replaced the original form with the API-integrated form */}
            <form 
              onSubmit={handleSubmit}
              className="contact-form-validated"
              noValidate
            >
              <div className="row">
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-page__form-input-box">
                    <input 
                      type="text" 
                      placeholder="Name of child" 
                      name="name" 
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-page__form-input-box">
                    <input 
                      type="text" 
                      placeholder="Age of child" 
                      name="age" 
                      value={formData.age}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="c nbol-xl-6 col-lg-6">
                  <div className="contact-page__form-input-box">
                    <input 
                      type="text" 
                      placeholder="D.O.B" 
                      name="dob" 
                      id="datepicker"
                      value={formData.dob}
                      onChange={handleInputChange}
                      readOnly
                      required
                    />
                    {/* <div className="contact-page__form-icon">
                      <i className="fas fa-calendar"></i>
                    </div> */}
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-page__form-input-box">
                    <input 
                      type="text" 
                      placeholder="Phone number 1" 
                      name="phone1" 
                      value={formData.phone1}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-page__form-input-box">
                    <input 
                      type="text" 
                      placeholder="Phone number 2" 
                      name="phone2" 
                      value={formData.phone2}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <div className="col-xl-6 col-lg-6">
                  <div className="contact-page__form-input-box">
                    <input 
                      type="text" 
                      placeholder="Address" 
                      name="address" 
                      value={formData.address}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-xl-12">
                  <div className="contact-page__form-btn-box">
                    <button 
                      type="submit" 
                      className="thm-btn contact-page__form-btn"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Submitting...
                        </>
                      ) : 'Make an Enquiry'}
                    </button>
                  </div>
                </div>
              </div>
            </form>
            <div className="result"></div>
          </div>
        </div>
      </section>
  
      <section className="contact-details">
        <div className="container">
          <div className="contact-details__inner">
            <div className="contact-details__inner-content">
              <div className="contact-details__shape-1 float-bob-y">
                <img src={`${config.baseUrl}/assets/images/shapes/contact-details-shape-1.png`} alt=""/>
              </div>
              <ul className="list-unstyled contact-details__list">
                <li>
                  <div className="icon">
                    <span className="icon-help"></span>
                  </div>
                  <div className="content">
                    <p>Have Question?</p>
                    <h4><a href="tel:04344255800;ext=878">04344 - 255800, 878</a></h4>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <span className="icon-mailbox"></span>
                  </div>
                  <div className="content">
                    <p>Write Email</p>
                    <h4><a href="mailto:rayofhope@acaindia.org">rayofhope@acaindia.org</a></h4>
                  </div>
                </li>
                <li>
                  <div className="icon">
                    <span className="icon-maps-and-flags"></span>
                  </div>
                  <div className="content">
                    <p>Visit Center</p>
                    <h4>Asian Christian Academy, Jeemangalam, Bagalur (P.O), Hosur, Krishnagiri (Dist.), Tamil Nadu - 635103</h4>
                  </div>
                </li>
                <li>
                  <div className="contact-details__social">
                    <a href="https://youtube.com/@rhca-india?si=Pu2jro4V4E-xB_l_" target='_blank'  rel="noopener noreferrer"><i class="fab fa-youtube"></i></a>
                                <a href="https://www.facebook.com/rayofhopeACA?mibextid=rS40aB7S9Ucbxw6v" target='_blank'  rel="noopener noreferrer"><i class="fab fa-facebook"></i></a>
                                <a href="https://www.linkedin.com/company/ray-of-hope-center-for-autism/" target='_blank'  rel="noopener noreferrer"><i class="fab fa-linkedin"></i></a>
                                <a href="https://www.instagram.com/rhcahosur?igsh=dmV5ZHA2czhsNWlv" target='_blank'  rel="noopener noreferrer"><i class="fab fa-instagram"></i></a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
   
      <section className="google-map-two">
        <iframe
          title="Google Maps Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4564.419517784099!2d77.85394981123915!3d12.801320918535346!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae75a06b6b2723%3A0xb5a227888b778e75!2sRay%20of%20Hope%20Center%20for%20Autism!5e1!3m2!1sen!2sin!4v1753941805524!5m2!1sen!2sin"
          className="google-map__two" 
          allowFullScreen
        ></iframe>
      </section>
    </div>
  );
}

export default ContactPage;